export default "__VITE_ASSET__BDPLoUtK__"